var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "27) Icon/close",
    opacity: 0.7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8857 16L23.6097 10.276C24.131 9.75469 24.131 8.91203 23.6097 8.39069C23.0883 7.86936 22.2457 7.86936 21.7243 8.39069L16.0003 14.1147L10.2763 8.39069C9.755 7.86936 8.91233 7.86936 8.391 8.39069C7.86967 8.91203 7.86967 9.75469 8.391 10.276L14.115 16L8.391 21.724C7.86967 22.2454 7.86967 23.088 8.391 23.6094C8.651 23.8694 8.99233 24 9.33367 24C9.675 24 10.0163 23.8694 10.2763 23.6094L16.0003 17.8854L21.7243 23.6094C21.9843 23.8694 22.3257 24 22.667 24C23.0083 24 23.3497 23.8694 23.6097 23.6094C24.131 23.088 24.131 22.2454 23.6097 21.724L17.8857 16Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8857 16L23.6097 10.276C24.131 9.75469 24.131 8.91203 23.6097 8.39069C23.0883 7.86936 22.2457 7.86936 21.7243 8.39069L16.0003 14.1147L10.2763 8.39069C9.755 7.86936 8.91233 7.86936 8.391 8.39069C7.86967 8.91203 7.86967 9.75469 8.391 10.276L14.115 16L8.391 21.724C7.86967 22.2454 7.86967 23.088 8.391 23.6094C8.651 23.8694 8.99233 24 9.33367 24C9.675 24 10.0163 23.8694 10.2763 23.6094L16.0003 17.8854L21.7243 23.6094C21.9843 23.8694 22.3257 24 22.667 24C23.0083 24 23.3497 23.8694 23.6097 23.6094C24.131 23.088 24.131 22.2454 23.6097 21.724L17.8857 16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_239)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLight);
export default __webpack_public_path__ + "static/media/closeLight.6908955a0e53bc7349ffb38ecc948bd8.svg";
export { ForwardRef as ReactComponent };